<template>
    <Modal @closed="$emit('close')" id="vlw_user_settings" class="vlw_user_settings" title="Instellingen" :open="true"
        :closable="true">
        <div class="p-4 w-full">
            <!-- Tabs -->
            <div class="vl-tabs__wrapper w-full mb-6">
                <ul class="vl-tabs m-0" role="tablist">
                    <li v-for="tab in tabs" :key="tab" class="vl-tab" :class="{ 'vl-tab--active': activeTab === tab }">
                        <a @click.prevent="activeTab = tab" class="vl-tab__link" href="#">
                            {{ tab }}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Tab content -->
            <ProfileSettings v-if="activeTab === 'Profiel'" />

            <WorkgroupSettings v-else-if="activeTab === 'Werkgroepen'" />
        </div>

    </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ProfileSettings from './settings/ProfileSettings.vue';
import WorkgroupSettings from './settings/WorkgroupSettings.vue';
export default {
  name: 'UserSettings',
  data() {
    return {
      tabs: ['Profiel', 'Werkgroepen'],
      activeTab: 'Profiel',
    };
  },
    components: {
        ProfileSettings,
        WorkgroupSettings,
    },
  computed: {
    ...mapGetters('metadata', ['userWorkgroups', 'getWorkgroupSimplifiedNameById']),
    ...mapGetters('authentication', ['userName', 'userEmail']),
    workgroups() {
      return this.userWorkgroups || [];
    },
    darkModeSetting: {
      get() {
        return this.$store.state.ui.isDarkMode;
      },
      set(value) {
        this.$store.commit('ui/UPDATE_DARK_MODE', value);
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('authentication/logout').then(() => {
        this.$router.push('/login');
      });
    }
  }
};
</script>

<style scoped>

.workgroup-info {
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1rem;
}

.workgroup-info small {
  font-size: 1.2rem;
  line-height: 1.2;
}

.vlw_user_settings {
    .vlp__modal__dialog {
        max-height: 600px;
        min-width: 800px;
    }

    /* Modern toggle animation */
    input:checked+div {
        background-color: #221abe;
        /* Indigo-600 */
    }

    input:checked+div+.dot {
        transform: translateX(100%);
        background-color: white;
    }

    .dot {
        transition: transform 0.3s ease;
    }
}
</style>